import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Popup, useMap, Marker } from 'react-leaflet';
import L from 'leaflet';
import { locomotorasService } from '../../services/api';
import api from '../../services/api';
import 'leaflet/dist/leaflet.css';

function CapaRedAV() {
  const map = useMap();
  useEffect(() => {
    const BASE = "https://services7.arcgis.com/XTupIrLX53AjaJqO/arcgis/rest/services/Red_Ferroviaria_de_Inter%C3%A9s_General___Adif__RFIG_CM_vista_2/FeatureServer/43/query";
    const filtro = "CODTRAMO LIKE '11%' OR CODTRAMO LIKE '12%' OR CODTRAMO LIKE '13%' OR CODTRAMO LIKE '14%'";
    
    const cargarBatch = async (offset) => {
      const url = `${BASE}?f=geojson&where=${encodeURIComponent(filtro)}&outFields=CODTRAMO,COD_EJE&resultOffset=${offset}&resultRecordCount=2000`;
      const resp = await fetch(url);
      const data = await resp.json();
      if (data.features && data.features.length > 0) {
        import('leaflet').then(L => {
          L.geoJSON(data, {
            style: { color: '#2563eb', weight: 2.5, opacity: 0.75 }
          }).addTo(map);
        });
        if (data.exceededTransferLimit) cargarBatch(offset + 2000);
      }
    };
    cargarBatch(0);
  }, [map]);
  return null;
}

export default function MapaFlota() {
  const [locomotoras, setLocomotoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalUbicacion, setModalUbicacion] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [sugerencias, setSugerencias] = useState([]);

  useEffect(() => {
    locomotorasService.getAll()
      .then(r => setLocomotoras(r.data.filter(l => l.activa)))
      .finally(() => setLoading(false));
  }, []);

  const buscarEstacion = async (q) => {
    setBusqueda(q);
    if (q.length < 2) { setSugerencias([]); return; }
    const r = await api.get(`/dependencias/?q=${encodeURIComponent(q)}&solo_av=true&limit=6`);
    setSugerencias(r.data);
  };

  const guardarUbicacion = async (dep) => {
    await api.post(`/locomotoras/set-ubicacion/${modalUbicacion.id}`, {
      cod_depend: dep.cod_depend, nombre: dep.nombre, lat: dep.lat, lon: dep.lon
    });
    const r = await locomotorasService.getAll();
    setLocomotoras(r.data.filter(l => l.activa));
    setModalUbicacion(null);
    setBusqueda(''); setSugerencias([]);
  };

  const colorLoco = (l) => {
    if ((l.litros_adblue || 0) < 105) return '#dc2626';
    if (((l.litros_combustible || 0) / (l.capacidad_combustible || 5000)) < 0.2) return '#ea580c';
    return '#16a34a';
  };

  const conUbicacion = locomotoras.filter(l => l.ubicacion_lat && l.ubicacion_lon);
  const sinUbicacion = locomotoras.filter(l => !l.ubicacion_lat || !l.ubicacion_lon);

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Mapa de flota</h2>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>
          {conUbicacion.length} posicionadas · {sinUbicacion.length} sin ubicacion
        </p>
      </div>

      <div style={{ display: 'flex', gap: 16, height: 'calc(100vh - 160px)' }}>
        <div style={{ flex: 1, borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e5e5' }}>
          <MapContainer center={[40.4, -3.7]} zoom={6} style={{ height: '100%', width: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="© OpenStreetMap" />
            <CapaRedAV />
            {conUbicacion.map((l, idx) => {
              // Offset para locomotoras en el mismo punto
              const mismosPunto = conUbicacion.filter(x => x.ubicacion_lat === l.ubicacion_lat && x.ubicacion_lon === l.ubicacion_lon);
              const offsetIdx = mismosPunto.findIndex(x => x.id === l.id);
              const offsetX = offsetIdx * 0.008;
              const offsetY = offsetIdx * 0.006;
              return (
              <Marker key={l.id} position={[l.ubicacion_lat + offsetY, l.ubicacion_lon + offsetX]}
                icon={L.divIcon({
                  className: '',
                  html: `
                    <div style="display:flex;flex-direction:column;align-items:center">
                      <div style="width:18px;height:18px;border-radius:50%;background:${colorLoco(l)};border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)"></div>
                      <div style="background:white;color:#1a1a1a;border:2px solid ${colorLoco(l)};border-radius:4px;padding:3px 8px;font-size:13px;font-weight:700;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,0.2);font-family:system-ui;margin-top:3px">${l.numero}</div>
                    </div>`,
                  iconAnchor: [30, 9]
                })}>
                <Popup>
                  <div style={{ fontSize: 13, minWidth: 160 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>🚂 {l.numero}</div>
                    <div style={{ color: '#888', marginBottom: 8 }}>{l.ubicacion_nombre}</div>
                    <div>KM: <strong>{l.km_actuales?.toLocaleString('es-ES')}</strong></div>
                    <div>AdBlue: <strong style={{ color: (l.litros_adblue||0) < 105 ? '#dc2626' : '#16a34a' }}>{(l.litros_adblue||0).toFixed(0)} L</strong></div>
                    <div>Combustible: <strong>{(l.litros_combustible||0).toFixed(0)} L</strong></div>
                    {l.servicio_asignado && <div style={{ marginTop: 6 }}>Servicio: <strong>{l.servicio_asignado.codigo}</strong></div>}
                    <button onClick={() => { setModalUbicacion(l); setBusqueda(''); setSugerencias([]); }}
                      style={{ marginTop: 8, width: '100%', padding: '6px', borderRadius: 6, border: '1px solid #ddd', background: '#f8f8f6', cursor: 'pointer', fontSize: 12 }}>
                      Cambiar ubicacion
                    </button>
                  </div>
                </Popup>
              </Marker>
              );
            })}
          </MapContainer>
        </div>

        <div style={{ width: 220, display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#555', marginBottom: 8 }}>Leyenda</div>
            {[['#16a34a','OK'],['#ea580c','REVISAR'],['#dc2626','INUTIL']].map(([c,l]) => (
              <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, marginBottom: 4 }}>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: c, display: 'inline-block' }} />{l}
              </div>
            ))}
          </div>

          {sinUbicacion.length > 0 && (
            <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 500, color: '#555', marginBottom: 8 }}>Sin ubicacion</div>
              {sinUbicacion.map(l => (
                <div key={l.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                  <span style={{ fontSize: 13, fontWeight: 500 }}>{l.numero}</span>
                  <button onClick={() => { setModalUbicacion(l); setBusqueda(''); setSugerencias([]); }}
                    style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11 }}>
                    Ubicar
                  </button>
                </div>
              ))}
            </div>
          )}

          <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: '#555', marginBottom: 8 }}>Posicionadas</div>
            {conUbicacion.map(l => (
              <div key={l.id} style={{ padding: '5px 0', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: colorLoco(l), display: 'inline-block' }} />
                  <span style={{ fontWeight: 500 }}>{l.numero}</span>
                </div>
                <div style={{ color: '#888', fontSize: 11, marginLeft: 14 }}>{l.ubicacion_nombre}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {modalUbicacion && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 500 }}
          onClick={e => { if (e.target === e.currentTarget) setModalUbicacion(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 380, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 16 }}>Ubicar — {modalUbicacion.numero}</h3>
            <input value={busqueda} onChange={e => buscarEstacion(e.target.value)}
              placeholder="Buscar estacion..." autoFocus
              style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, boxSizing: 'border-box', marginBottom: 8 }} />
            {sugerencias.length > 0 && (
              <div style={{ border: '1px solid #ddd', borderRadius: 8, overflow: 'hidden' }}>
                {sugerencias.map((dep, i) => (
                  <div key={i} onClick={() => guardarUbicacion(dep)}
                    style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: 13 }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8f8f6'}
                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    <div style={{ fontWeight: 500 }}>{dep.nombre}</div>
                    <div style={{ fontSize: 11, color: '#888' }}>{dep.cod_depend}</div>
                  </div>
                ))}
              </div>
            )}
            <button onClick={() => setModalUbicacion(null)}
              style={{ marginTop: 12, width: '100%', padding: '8px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
